import Vue from 'vue';

export default {
    async marketPackages() {
        const response = await Vue.axios.get('prikljucek/storitve/getNaborTrznihPaketov?idTehnoloskaOsnova=44');
        return response.data;
    },
}
